import { Menu } from 'lucide-react';

import { useAuthStore } from '@/stores/authStore';
import { BatchSwitcher } from '@/components/BatchSwitcher';
import { CommandPalette } from '@/components/CommandPalette';
import { NotificationBell } from '@/components/NotificationBell';
import { MessageIconButton } from '@/components/MessageIconButton';
import { UserMenu } from '@/components/UserMenu';
import { useStudentThread } from '@/lib/hooks/useMessages';

interface StudentTopBarProps {
  streakDays?: number;
  unreadCount?: number;
  onMenu: () => void;
}

export function StudentTopBar({ unreadCount = 0, onMenu }: StudentTopBarProps) {
  const { user } = useAuthStore();
  const { data: thread } = useStudentThread();
  const lastMessage = thread?.messages?.[thread.messages.length - 1];
  const msgCount = lastMessage && lastMessage.sender_id !== user?.id ? 1 : 0;

  return (
    <header className="flex h-[90px] flex-shrink-0 items-center gap-3 border-b border-[#f1f1f1] bg-white px-4 lg:px-8">
      {/* Mobile menu */}
      <button
        type="button"
        onClick={onMenu}
        aria-label="Open menu"
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted lg:hidden"
      >
        <Menu className="h-5 w-5" />
      </button>

      {/* Batch switcher */}
      <BatchSwitcher />

      {/* Search — compact icon on mobile, centered pill on desktop */}
      <div className="flex flex-1 justify-end md:justify-center">
        <div className="w-auto md:w-full md:max-w-lg">
          <CommandPalette />
        </div>
      </div>

      {/* Right: bell + user profile */}
      <div className="flex shrink-0 items-center gap-3">
        <MessageIconButton count={msgCount} to="/messages" className="lg:hidden" />

        <NotificationBell unreadCount={unreadCount} />

        <UserMenu />
      </div>
    </header>
  );
}
